import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import TwitterIcon from '@mui/icons-material/Twitter'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { Grid, InputAdornment } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { ControlledTextField } from '../ControlledTextField'
import { FieldContainer } from '../FieldContainer'
import { TikTokIcon } from '../Icons/TikTokIcon'
import { TwitchIcon } from '../Icons/TwitchIcon'
import { RangeSelect } from './RangeSelect'

export const Social = () => {
  const { watch } = useFormContext()
  const fb = watch('fb')
  const ig = watch('ig')
  const yt = watch('yt')
  const tw = watch('tw')
  const tiktok = watch('tiktok')
  const twitch = watch('twitch')

  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={7}>
            <ControlledTextField
              name='fb'
              label='Facebook Page / Profile URL'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <FacebookIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <RangeSelect
              name='fbRange'
              disabled={fb === undefined || fb === null || fb === ''}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={7}>
            <ControlledTextField
              name='ig'
              label='Instagram Handle'
              prefix='@'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <InstagramIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <RangeSelect
              name='igRange'
              disabled={ig === undefined || ig === null || ig === ''}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={7}>
            <ControlledTextField
              name='yt'
              label='YouTube Channel URL'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <YouTubeIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <RangeSelect
              name='ytRange'
              disabled={yt === undefined || yt === null || yt === ''}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={7}>
            <ControlledTextField
              name='tw'
              label='Twitter Username'
              prefix='@'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <TwitterIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <RangeSelect
              name='twRange'
              disabled={tw === undefined || tw === null || tw === ''}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={7}>
            <ControlledTextField
              name='tiktok'
              label='TikTok Username'
              prefix='@'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <TikTokIcon
                      fontSize='small'
                      sx={{
                        color: 'grey.600'
                      }}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <RangeSelect
              name='tiktokRange'
              disabled={
                tiktok === undefined || tiktok === null || tiktok === ''
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={7}>
            <ControlledTextField
              name='twitch'
              label='Twitch Handle'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <TwitchIcon
                      fontSize='small'
                      sx={{
                        color: 'grey.600'
                      }}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={5}>
            <RangeSelect
              name='twitchRange'
              disabled={
                twitch === undefined || twitch === null || twitch === ''
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </FieldContainer>
  )
}
